import axios from "axios";

export const setUserDetailsForAgents = async ({ userID, emailID }) => {
  const path = `/api/admin/v1/user/setUserDetailsForAgents/${userID}`;
  const userDetails = {
    emailID,
  };
  const headers = {
    "Content-Type": "application/json",
  };
  const { status, data } = await axios.post(path, userDetails, { headers });
  return { status, data };
};
